import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class PubertyScene extends MinigameScene {
    //Images
    private popParticles !: Phaser.GameObjects.Particles.ParticleEmitter;
    private failParticles !: Phaser.GameObjects.Particles.ParticleEmitter;

    private endAnimation !: object;
    private endImage !: Phaser.GameObjects.Image;
    private animationAngle = 0;

    //values
    private spawnRate = {min: 300, max: 700};
    private pimpleSize = {start: 0.2, end: 1};
    private pimpleTimeToSplash = 2500;
    private pimpleTimeToDestroy = 300;

    private animFPS = 60;

    private spawnAreas = [
        {x1: 325, x2: 515, y1: 200, y2: 415},
        {x1: 290, x2: 325, y1: 200, y2: 390},
        {x1: 250, x2: 290, y1: 220, y2: 330},
        {x1: 515, x2: 560, y1: 260, y2: 390},
        {x1: 560, x2: 600, y1: 220, y2: 350},
        {x1: 330, x2: 380, y1: 160, y2: 200},
    ];

    //logic vars
    private spawnTimer = 0;
    private pimples : Phaser.GameObjects.Image[] = [];

    private animTimer = 0;
    private isAnimating = false;

    constructor(){
        super ({
            sceneName: CONST.SCENES.PUBERTY,
            duration: 15000,
            startScreenColor: 0xF4C1FF,
            startText: "PUBERTY!",
            startTextColor: 0x323232,
            endScreen: CONST.PUBERTY.END,
            nextScene: CONST.SCENES.FINDHER,
            endButtons: {
                normalNoSkip: {x: 426.5, y: 411, scale: 1.30},
                normalWithSkip: {x: 283, y: 411, scale: 1.30},
                skip: {x: 570, y: 411, scale: 1.30}
            }
          })

          var spawnAreaSum = 0;
          this.spawnAreas.forEach((spawnArea) => {
            spawnAreaSum += (spawnArea.x2 - spawnArea.x1) * (spawnArea.y2- spawnArea.y1);
          
            spawnArea.areaSum = spawnAreaSum;
        });
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.spawnTimer = 0;
        this.pimples = [];
        this.animTimer = 0;
        this.isAnimating = false;
    }

    _preload(){
    }

    _create(){
        this.input.topOnly = false;

        this.add.image(442, 380, CONST.PUBERTY.BACKGROUND).setScale(1.252, 1.252).setDepth(0);
        this.add.image(135, 424, CONST.PUBERTY.POP_TEXT).setDepth(1);

        this.createParticles();

        this.endAnimation = this.cache.json.get(CONST.ANIMATIONS.PUBERTYEND);

        //spawn area vizualization
        /*this.spawnAreas.forEach((spawnArea) => {
            this.add.graphics({fillStyle: {color: 0x0000ff, alpha: 0.4}})
                    .fillRect(spawnArea.x1, spawnArea.y1, spawnArea.x2-spawnArea.x1, spawnArea.y2-spawnArea.y1);
        })*/
    }

    private createParticles(){
        var particles = this.add.particles(CONST.PUBERTY.PARTICLE).setDepth(9);
        var popParticleConfig = {
            active: true,
            visible: true,
            on: false,
            frequency: -1,
            gravityY: 1000,
            timeScale: 1,
            blendMode: 0,
            accelerationY: -200,
            lifespan: 500,
            scale: {start: 1, end: 0, ease: "Quad.easeOut"},
            speed: {min: -530, max: 530, ease: "Linear"},
        }

        var failParticleConfig = {
            active: true,
            visible: true,
            on: false,
            radial: true,
            frequency: 50,
            maxParticles: 200,
            gravityY: 1000,
            timeScale: 1,
            blendMode: 0,
            accelerationY: -100,
            quantity: 2,
            lifespan: 2000,
            scale: {start: 1, end: 0, ease: "Quad.easeOut"},
            speed: {min: -530, max: 530, ease: "Linear"},
        }

        this.popParticles = particles.createEmitter(popParticleConfig);
        this.failParticles = particles.createEmitter(failParticleConfig);
    }

    _update(time: number, delta: number){
        if (this.isAnimating){
            this.animTimer += delta;
            this.positionImageOnAnimation(this.animTimer, this.endImage, this.endAnimation, 0, 250, this.animationAngle, 1.1);
        }

        if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
        this.spawnTimer -= delta;
        if (this.spawnTimer <= 0){
            this.spawnTimer = this.calculateNewTimer();
            this.spawnPimple();
        }


        this.pimples.forEach(pimple => {pimple.update(delta)});
    }

    private calculateNewTimer(){
        return this.spawnRate.min + Math.random()*(this.spawnRate.max - this.spawnRate.min);
    }

    private spawnPimple(){
        var spawnPos = this.calculateNewSpawnPosition();
        //("spawning pimple " + spawnPos.x + " " + spawnPos.y);

        var pimple = this.add.image(spawnPos.x, spawnPos.y, CONST.PUBERTY.PIMPLE)
                        .setDepth(10)
                        .setInteractive({ useHandCursor: true })
                        .setScale(this.pimpleSize.start, this.pimpleSize.start);

        pimple.on("pointerdown", () =>{
            pimple.destroy();
        });

        pimple.lifeTime = 0;
        pimple.deathTime = 0;
        pimple.deathSize = 1;
        pimple.isAlive = true;
        pimple.failed = false;

        pimple.update = (delta: number) => {
            if (pimple.isAlive){
                //Increase pimple size if alive
                pimple.lifeTime += delta;
                if (pimple.lifeTime > this.pimpleTimeToSplash){
                    pimple.failed = true;
                    pimple.destroy();
                    return;
                }

                var newScale = this.pimpleSize.start + (pimple.lifeTime/this.pimpleTimeToSplash) * (this.pimpleSize.end - this.pimpleSize.start);
                pimple.setScale(newScale, newScale);

            } else {
                //Pop pimple if dead!
                pimple.deathTime += delta;
                if (pimple.deathTime > this.pimpleTimeToDestroy){
                    pimple.setVisible(false);
                    return;
                }

                var newScale = pimple.deathSize -  (pimple.deathTime/this.pimpleTimeToDestroy) * (pimple.deathSize);
                pimple.setScale(newScale, newScale);
            }
        };

        pimple.destroy = () => {
            if (!pimple.isAlive) return;

            pimple.isAlive = false;
            pimple.setInteractive(false);
            pimple.deathSize = pimple.scaleX;

            if (pimple.failed){
                pimple.setVisible(false);
                this.triggerLoss();
                this.failParticles.setPosition(pimple.x, pimple.y).start();
            } else {
                this.sound.play(CONST.AUDIO.POP, {detune: this.getDetune()});
                this.popParticles.explode(30, pimple.x, pimple.y);
            } 
        }

        this.pimples.push(pimple);
    }

    private calculateNewSpawnPosition(){
        var spawnAreaSum = this.spawnAreas[this.spawnAreas.length - 1].areaSum;
        var randomArea = Math.floor(Math.random() * spawnAreaSum);

        for (var i = 0; i < this.spawnAreas.length; i++){
            if (this.spawnAreas[i].areaSum >= randomArea){
                return {x: this.randomIntFromInterval(this.spawnAreas[i].x1, this.spawnAreas[i].x2),
                    y: this.randomIntFromInterval(this.spawnAreas[i].y1, this.spawnAreas[i].y2)}
            }
        }        
    }

    private randomIntFromInterval(min: number,max: number){
        return Math.floor(Math.random()*(max-min+1)+min);
    }

    _timeout(){
        this.triggerWin();
    }

    _afterLoss(){
    }

    _afterWin(){
    }

    private triggerWin(){
        //trigger win after 1 second and load next scene
        this.winGame(2300);

        this.animationAngle = 0;
        this.endGameAnim();
    }

    private triggerLoss(){
        this.loseGame(1500);

        this.animationAngle = 180;
        this.endGameAnim();

    }

    private endGameAnim(){
        this.endImage = this.add.image(0, 0, CONST.PUBERTY.BRACES).setScale(0, 0).setDepth(5);
        this.animTimer = 0;
        this.isAnimating = true;
    }

    private positionImageOnAnimation(timer: number, image: Phaser.GameObjects.Image, animation: object, xOffset: number = 0, yOffset: number = 0, angleOffset: number = 0, scaleMultiplier: number = 1){
        //Get frame
        var frameIndex = Math.floor(timer * (this.animFPS / 1000));
        if (frameIndex >= animation.frames.length){
            frameIndex = animation.frames.length - 1;
        }

        var frame = animation.frames[frameIndex];

        //position image to frame
        image.setPosition(frame.x + xOffset, frame.y + yOffset)
            .setScale(parseFloat(frame.scaleX) * scaleMultiplier, parseFloat(frame.scaleY) * scaleMultiplier)
            .setAngle(parseFloat(frame.angle) + angleOffset);
    }

}